import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/(app)/(dashboard)/calendar/calendar-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DemoModeScope"] */ "/opt/build/repo/hooks/useDemoMode.tsx");
